// SFGreeting.tsx — full-width gradient greeting banner (Sprint 83, ADR-082).
// Faithful port of the prototype's SFGreeting (home_sf.jsx) using the Atrium
// greeting gradient + tokens. Brand = CondoPro.
import React from 'react';

export interface SFKpiChip {
  /** Label (eyebrow, uppercased by CSS). */
  l: string;
  /** Value. */
  v: React.ReactNode;
  /** Optional delta string (e.g. "▲ 4.2%"). */
  d?: React.ReactNode;
}

export interface SFGreetingProps {
  /** Greeting headline, e.g. "Welcome home, Amara". */
  hi: React.ReactNode;
  /** Sub-line content (rendered after the role badge). */
  sub?: React.ReactNode;
  /** Role badge pill text, e.g. "OWNER". */
  badge?: string;
  /** Optional KPI summary strip (omitted on the Owner home). */
  chips?: SFKpiChip[];
  /** Optional header action buttons (use .hb .solid / .hb .ghost). */
  btns?: React.ReactNode;
}

export const SFGreeting: React.FC<SFGreetingProps> = ({ hi, sub, badge, chips, btns }) => (
  <div className="sfhead">
    <div className="gr">
      <div>
        {/* Page h1 (WCAG 1.3.1 / 2.4.6): the greeting is the document's main
            heading for each role home. Styled by `.hi`, reset of UA margins. */}
        <h1 className="hi" style={{ margin: 0 }}>{hi}</h1>
        <div className="sub">
          {badge && <span className="rbadge">{badge}</span>}
          {sub}
        </div>
      </div>
      {btns && <div className="hbtns">{btns}</div>}
    </div>
    {chips && chips.length > 0 && (
      <div className="sfchips">
        {chips.map((c, i) => (
          <div className="sfchip" key={i}>
            <div className="cl">{c.l}</div>
            <div className="cv num">
              {c.v}
              {c.d && <span className="dlt">{c.d}</span>}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default SFGreeting;
